var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',{staticClass:"app-layout",class:{'app-layout--collpase': _vm.isCollapsed || _vm.appBreakpoint}},[_c('AppSider'),_c('Layout',{staticClass:"app-main"},[_c('AppHeader'),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }